import { Strike as StrikeToExtend } from '@tiptap/extension-strike';

export const Strike = StrikeToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
